import { experienceQueryKeys as e } from "./useExperienceQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { experiencesApi as r } from "@maat/api-main";
//#region src/experiences/useUpdateExperienceMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ experienceId: e, data: t }) => r.updateExperience(e, t),
		onSuccess: (t, { experienceId: n }) => {
			i.invalidateQueries({ queryKey: e.list() }), i.invalidateQueries({ queryKey: e.detail(n) });
		}
	});
};
//#endregion
export { i as useUpdateExperienceMutation };
